<template>
    <div>
        <div class="field-checkbox">
            <Checkbox
                v-model="model.isDeleteChilds"
                :binary="true"
                inputId="isDeleteChilds"
                @update:modelValue="onChange" />
            <label for="isDeleteChilds">{{ $t('lang.templates.delete_child_projects_list.checkbox_label') }}</label>
        </div>
        <Accordion :multiple="true">
            <AccordionTab
                v-if="projects.cluster"
                :header="$t('lang.templates.delete_child_projects_list.cluster_label')"
            >
                <div>
                    <a
                        :href="getClusterUrl(projects.cluster.uid)"
                        target="_blank"
                        class="text-xs"
                    >
                        {{ projects.cluster.name }}
                    </a>
                </div>
            </AccordionTab>
            <AccordionTab
                v-if="projects.serp"
                :header="$t('lang.templates.delete_child_projects_list.serp_label', [projects.serp.length])"
            >
                <div class="flex flex-column gap-2">
                    <a
                        v-for="project in projects.serp"
                        :href="getSerpUrl(project.id)"
                        target="_blank"
                        class="text-xs"
                    >
                        {{ project.name }}
                    </a>
                </div>
            </AccordionTab>
            <AccordionTab
                v-if="projects.wordstat"
                :header="$t('lang.templates.delete_child_projects_list.wordstat_label', [projects.wordstat.length])"
            >
                <div class="flex flex-column gap-2">
                    <a
                        v-for="project in projects.wordstat"
                        :href="getWsUrl(project.id)"
                        target="_blank"
                        class="text-xs"
                    >
                        {{ project.name }}
                    </a>
                </div>
            </AccordionTab>
        </Accordion>
    </div>
</template>

<script>
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Checkbox from "primevue/checkbox";

export default {
    name: "TemplatesDeleteChildProjectsList",
    emits: ['update:isDeleteChilds'],
    props: {
        isDeleteChilds: {
            type: Boolean,
            required: true,
        },
        projects: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            model: {
                isDeleteChilds: false,
            }
        }
    },
    mounted() {
        this.model.isDeleteChilds = this.isDeleteChilds;
    },
    methods: {
        getClusterUrl(clusterUid) {
            return sprintf('/%s/clustering-list/%s', window.locale, clusterUid);
        },
        getSerpUrl(serpId) {
            return sprintf('/%s/serp-list/%d', window.locale, serpId);
        },
        getWsUrl(wsId) {
            return sprintf('/%s/wordstat-list/%d', window.locale, wsId);
        },
        onChange(event) {
            this.$emit('update:isDeleteChilds', event);
        },
    },
    components: {
        Accordion,
        AccordionTab,
        Checkbox,
    }
}
</script>

<style scoped>
:deep(.p-accordion-header) {
    font-size: 13px;
}
:deep(.p-accordion-header) a {
    font-weight: 500 !important;
    padding: 10px !important;
}
:deep(.p-accordion-header) svg {
    width: 10px;
}
</style>
